import { z } from "zod";

export const publishSearchSchema = z.object({
  tab: z.enum(["schedule", "insights", "settings"]).optional(),
  view: z.enum(["overview", "posts", "audience"]).optional(),
});

export type PublishSearch = z.infer<typeof publishSearchSchema>;
export type PublishTab = NonNullable<PublishSearch["tab"]>;
export type InsightsView = NonNullable<PublishSearch["view"]>;
